// extracted by mini-css-extract-plugin
export default {"tableRow":"survey_tableRow__cq5bD","tableCell":"survey_tableCell__Fpg34"};